import { formatCredits } from 'features/usage/components/usage-credits';
import { useCreditSummary } from '../hooks/use-credits';

/** The organization's credit count as a small pill, shown at the right of "Credits" in the profile menu. */
export const CreditBalanceCount = () => {
  const { data: summary } = useCreditSummary(false);

  if (!summary?.enabled) return null;

  // `!flex-none`: dropdown menu items stretch every direct span child (`[&>span]:flex-1`).
  return (
    <span className="ml-auto inline-flex !flex-none items-center gap-1.5 rounded-full bg-emerald-500/10 px-2 py-0.5 text-[11px] font-semibold leading-4 tabular-nums text-emerald-600 dark:bg-emerald-400/10 dark:text-emerald-300">
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />
      {formatCredits(summary.balanceCredits)}
    </span>
  );
};
